import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const SectionTitleWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.sectionTitleSpacingBottom};
`;

export const SectionWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.sectionSpacingY};
`;

export const OtherPaymentTitleWrapper = styled.div`
  display: ${({ theme }: ThemeStyle) => theme.otherPaymentMethodTitleDisplay};
  margin-bottom: 16px;
`;

export const BuyerAssuranceWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: 90px;

  .buyer-assurance {
    display: ${({ theme }) => theme.displayBuyerAssurancePP1};
  }
`;
